import { createAndFireEvent } from '@atlaskit/analytics-next';
export var fabricElementsChannel = 'fabric-elements';
export var createAndFireEventInElementsChannel = createAndFireEvent(fabricElementsChannel);